import React, { useEffect, useState } from "react";
import { Button, FormGroup, Input, Label, Modal, ModalBody, Spinner, Table } from "reactstrap";

import api from "../../../services/api";

// Cadastro manual do prazo que falta (épico PO1-2886, pedido do Rodrigo em
// 03/10/2026). A prévia mostra onde cada grupo de NFs vai ser gravado: o
// cabeçalho é por origem (remetente), modal, negócio, serviço e tipo, a mesma
// chave que o motor de prazo procura. Só inclui faixa: nunca altera a que existe.

const SITUACAO = {
  incluir_faixa: { texto: "Inclui a faixa na tabela", cor: "var(--everlog-status-success)" },
  criar_tabela: { texto: "Cria a tabela e a faixa", cor: "var(--everlog-status-warning)" },
  faixa_existente: { texto: "Já cadastrado (não altera)", cor: "var(--everlog-card-muted)" },
  sem_origem: { texto: "Remetente sem cidade (ignorado)", cor: "var(--everlog-status-danger)" },
};

const labelStyle = { fontSize: "0.82rem", color: "var(--everlog-card-muted)", marginBottom: "0.25rem" };
const inputStyle = {
  background: "var(--everlog-card-surface-field)",
  borderColor: "var(--everlog-card-border)",
  color: "var(--everlog-card-title)",
  boxShadow: "none",
  maxWidth: 140,
};
const secaoStyle = {
  color: "var(--everlog-card-muted)",
  fontSize: "0.78rem",
  fontWeight: 600,
  textTransform: "uppercase",
  letterSpacing: "0.05em",
  marginBottom: "0.5rem",
};
const caixaStyle = {
  border: "1px solid var(--everlog-card-border)",
  borderRadius: 6,
  padding: "0.6rem 0.75rem",
  marginBottom: "1rem",
  fontSize: "0.85rem",
  color: "var(--everlog-card-text)",
};

const erroDe = (e, padrao) =>
  (e && e.response && e.response.data && e.response.data.error) || (e && e.message) || padrao;

const textoOrigem = (g) => [g.cidadeOrigem, g.ufOrigem].filter(Boolean).join("/") || "Sem cidade";

export default function CadastroPrazoModal({ linha, periodo, onClose }) {
  const [previa, setPrevia] = useState(null);
  const [carregando, setCarregando] = useState(true);
  const [dias, setDias] = useState("");
  const [salvando, setSalvando] = useState(false);
  const [erro, setErro] = useState("");
  const [resultado, setResultado] = useState(null);

  const params = {
    idEmbarcador: linha.idEmbarcador,
    idTransportadora: linha.idTransportadora,
    idCidade: linha.idCidade,
    de: periodo.de,
    ate: periodo.ate,
  };

  useEffect(() => {
    let vivo = true;
    api
      .get("/trackfy/prazo/cobertura/cadastro", { params })
      .then((r) => vivo && setPrevia(r.data || null))
      .catch((e) => vivo && setErro(erroDe(e, "Não foi possível montar a prévia do cadastro.")))
      .finally(() => vivo && setCarregando(false));
    return () => {
      vivo = false;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const grupos = (previa && previa.grupos) || [];
  const gravaveis = grupos.filter((g) => g.situacao === "incluir_faixa" || g.situacao === "criar_tabela");
  const diasNum = Number(dias);
  const diasOk = Number.isInteger(diasNum) && diasNum >= 1 && diasNum <= 90;
  const podeSalvar = !carregando && !salvando && !resultado && gravaveis.length > 0 && diasOk;

  const salvar = async () => {
    setSalvando(true);
    setErro("");
    try {
      const r = await api.post("/trackfy/prazo/cobertura/cadastro", { ...params, dias: diasNum });
      setResultado(r.data || {});
    } catch (e) {
      setErro(erroDe(e, "Não foi possível cadastrar o prazo."));
    } finally {
      setSalvando(false);
    }
  };

  const fechar = () => onClose(Boolean(resultado && resultado.faixasIncluidas));

  return (
    <Modal isOpen toggle={fechar} modalClassName="modal-align-top" fade={false} style={{ maxWidth: 680 }}>
      <div
        style={{
          background: "var(--everlog-card-surface-flat)",
          borderRadius: "0.4rem",
          border: "1px solid var(--everlog-card-border)",
          overflow: "hidden",
        }}
      >
        <div
          style={{
            background: "var(--theme-accent-glow)",
            padding: "0.9rem 1.25rem",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            borderBottom: "1px solid var(--everlog-card-border)",
          }}
        >
          <span style={{ color: "var(--everlog-card-title)", fontWeight: 600, fontSize: "1rem" }}>
            <i className="tim-icons icon-time-alarm" style={{ marginRight: 8 }} />
            Cadastrar prazo de entrega
          </span>
          <button
            type="button"
            aria-label="Fechar"
            style={{ background: "none", border: "none", color: "var(--everlog-card-muted)", cursor: "pointer", fontSize: "1.2rem", lineHeight: 1 }}
            onClick={fechar}
          >
            ×
          </button>
        </div>

        <ModalBody style={{ padding: "1.25rem", background: "var(--everlog-card-surface-flat)" }}>
          <div style={caixaStyle}>
            <div>
              <strong>{linha.transportadora || `#${linha.idTransportadora}`}</strong> para{" "}
              <strong>{[linha.cidade, linha.uf].filter(Boolean).join("/")}</strong>
            </div>
            <div style={{ color: "var(--everlog-card-muted)", fontSize: "0.8rem" }}>
              {linha.embarcador} · {linha.semPrevisao} NF(s) sem previsão no período
            </div>
          </div>

          <p style={secaoStyle}>Onde vai ser gravado</p>
          {carregando ? (
            <div style={{ fontSize: "0.85rem", color: "var(--everlog-card-muted)", marginBottom: "1rem" }}>
              <Spinner size="sm" /> Montando a prévia...
            </div>
          ) : (
            <Table size="sm" className="hub-thead-accent" style={{ marginBottom: "1rem" }}>
              <thead className="text-primary">
                <tr>
                  <th>Origem</th>
                  <th>Tabela de prazo</th>
                  <th className="text-right">NFs</th>
                  <th>Situação</th>
                </tr>
              </thead>
              <tbody>
                {grupos.map((g) => (
                  <tr key={`${g.idCidadeOrigem}-${g.idModal}-${g.idNegocio}-${g.servico}-${g.idTipoServico}`}>
                    <td>{textoOrigem(g)}</td>
                    <td>{g.idPrazoTabela ? `${g.nomeTabela || "Tabela"} (#${g.idPrazoTabela})` : "Nova tabela"}</td>
                    <td className="text-right">{g.nfs}</td>
                    <td style={{ color: (SITUACAO[g.situacao] || {}).cor }}>
                      {(SITUACAO[g.situacao] || {}).texto || g.situacao}
                      {g.situacao === "faixa_existente" && g.faixasExistentes && g.faixasExistentes.length
                        ? ` · ${g.faixasExistentes[0].dias} dias`
                        : ""}
                    </td>
                  </tr>
                ))}
                {!grupos.length ? (
                  <tr>
                    <td colSpan={4} style={{ color: "var(--everlog-card-muted)" }}>
                      Nenhuma NF sem previsão para esta combinação no período.
                    </td>
                  </tr>
                ) : null}
              </tbody>
            </Table>
          )}

          {!resultado ? (
            <FormGroup>
              <Label for="cadastro-prazo-dias" style={labelStyle}>
                Prazo de entrega (dias úteis)
              </Label>
              <Input
                id="cadastro-prazo-dias"
                type="number"
                min={1}
                max={90}
                step={1}
                value={dias}
                onChange={(event) => setDias(event.target.value)}
                style={inputStyle}
                disabled={salvando || !gravaveis.length}
              />
              <small style={{ color: "var(--everlog-card-muted)" }}>
                Vale para a cidade inteira (faixas de CEP do destino). O que já está cadastrado não muda.
              </small>
            </FormGroup>
          ) : (
            <div style={{ ...caixaStyle, borderColor: "var(--everlog-status-success)" }} role="status">
              {resultado.faixasIncluidas
                ? `Prazo de ${resultado.dias} dias úteis cadastrado: ${resultado.faixasIncluidas} faixa(s)` +
                  `${resultado.tabelasCriadas ? ` e ${resultado.tabelasCriadas} tabela(s) nova(s)` : ""}. ` +
                  `${resultado.nfsRecalculo ? `${resultado.nfsRecalculo} NF(s) enviadas para recálculo agora.` : "As NFs serão recalculadas pela varredura."}`
                : "Nada foi incluído: o prazo já estava cadastrado."}
            </div>
          )}

          {erro ? (
            <div
              role="alert"
              style={{
                background: "var(--everlog-status-danger)",
                color: "var(--everlog-on-accent-text)",
                padding: "0.6rem 0.75rem",
                borderRadius: 4,
                marginBottom: "1rem",
                fontSize: "0.85rem",
              }}
            >
              {erro}
            </div>
          ) : null}

          <div
            style={{
              display: "flex",
              justifyContent: "flex-end",
              gap: "0.5rem",
              borderTop: "1px solid var(--everlog-card-border)",
              paddingTop: "1rem",
            }}
          >
            <Button color="secondary" size="sm" onClick={fechar} disabled={salvando}>
              {resultado ? "Fechar" : "Cancelar"}
            </Button>
            {!resultado ? (
              <Button color="primary" size="sm" onClick={salvar} disabled={!podeSalvar}>
                {salvando ? <Spinner size="sm" style={{ marginRight: 6 }} /> : null}
                {salvando ? "Cadastrando..." : "Cadastrar prazo"}
              </Button>
            ) : null}
          </div>
        </ModalBody>
      </div>
    </Modal>
  );
}
